<template>
  <div class="columns is-centered is-mobile">
    <div class="column login-form-wrapper">
      <div class="login-form">
        <div class="login-form__icon">
          <b-icon pack="far" icon="user-circle"></b-icon>
        </div>
        <div class="login-form__title">Log in to your Enhancify account</div>
        <div class="login-form__subtitle">Manage your co-branded page, profile, company details.
          View and download reports and more</div>

        <validation-observer v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(login)">
            <div class="login-form__item">
              <validation-provider name="Email" v-slot="{ errors }" rules="required|email">
                <b-field label="Email"
                         class="email-field"
                         :type="{ 'is-danger':errors.length || isInvalid }" :message="errors">
                  <b-input size="is-medium" name="username" v-model.trim="username"
                           type="email"
                           custom-class="input-email"
                           placeholder="Enter your email address"
                           autocomplete="username"
                           ref="emailInput"
                           @focus="emailFocused"
                           maxlength="250"></b-input>
                </b-field>
              </validation-provider>
            </div>

            <div class="login-password login-form__item">
              <validation-provider name="Password" v-slot="{ errors }" rules="required">
                <b-field label="Password"
                         class="password-field"
                         :type="{ 'is-danger':errors.length || isInvalid }" :message="errors">
                  <b-input ref="passwordField"
                           custom-class="input-password"
                           size="is-medium" v-model="password" type="password"
                           autocomplete="current-password"
                           :password-reveal="isPasswordFocused"
                           @focus="passwordFocused"
                           placeholder="Enter your password"  maxlength="32"></b-input>
                </b-field>
              </validation-provider>
            </div>
            <div class="login-form__item">
              <div class="login-form__link">
                <router-link tag="a" :to="{ name: 'Restore', params: { email: username } }">
                  Forgot password?
                </router-link>
              </div>
            </div>
            <div class="login-form__item">
              <p class="control">
                <button class="button is-success submit-button" type="submit">
                  LOG IN
                </button>
              </p>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_SPLASH } from '../store/mutations';
import { LOGIN } from '../store/modules/auth/actions';

export default {
  name: 'Login',

  data() {
    return {
      username: '',
      password: '',
      isInvalid: false,
      isPasswordFocused: false,
    };
  },


  methods: {
    passwordFocused() {
      this.isPasswordFocused = true;
    },
    emailFocused() {
      this.isPasswordFocused = false;
    },
    login() {
      const { username, password } = this;
      this.$store.commit(SET_SPLASH, true);
      this.$store.dispatch(`auth2/${LOGIN}`, { username, password })
        .then(() => {
          this.toast('Login successful!');
          this.$store.commit(SET_SPLASH, false);
          this.$router.push('/');
        }).catch((error) => {
          if (!error.response || (error.response && error.response.status !== 423)) {
            this.toast('Invalid login or password', 'is-danger', 5000);
          }

          // if interceptor failed
          setTimeout(() => {
            this.isInvalid = true;
            this.$store.commit(SET_SPLASH, false);
          }, 2000);
        });
    },

    toast(message, type = 'is-success', duration = 5000) {
      this.$buefy.toast.open({ message, type, duration });
    },

  },

};
</script>

<style scoped lang="stylus">
@require "../assets/style/modern/variables.styl";
.login-form-wrapper >>> input.input-password[type="password"]::-ms-reveal
  display none
.login-form-wrapper >>> .input-email,
.login-form-wrapper >>> .input-password
  font-size 16px
  height 48px
.password-field >>> .label,
.email-field >>> .label
  font-weight 500
.email-field >>> p.help,
.password-field >>> p.help
  font-size 16px
password-field >>> span.icon,
.email-field >>> span.icon
  height 48px
.login-form-wrapper
  display flex
  justify-content center
  padding-right 0
  .password-field >>> i.mdi:is(.mdi-eye,.mdi-eye-off)
    color #8FA7B3
  .login-form
    @media (max-width: $breakpoints.md)
      padding 30px 16px
    max-width 750px
    margin 20px 20px 0 20px
    width 100%;
    background white
    border-radius 6px
    padding 30px 55px
    box-shadow 0 18px 32px rgba(156, 173, 173, 0.2);
    color #293033
    &__icon, &__title, &__subtitle, &__subtitle_bold
      text-align center
    &__item
      margin-bottom 10px
      p.control
        text-align center
      &.login-password
        padding-bottom 8px
    &__icon
      margin-bottom 15px
      color: #17B548
      font-size 2rem
    &__title
      font-weight bold
      font-size 28px
      margin-bottom 10px
      color #293033
    &__subtitle, &__subtitle_bold
      margin-bottom 30px
      font-size 18px
      color #293033
    &__subtitle_bold
      font-weight bold
    &__link
      color #188DFC
      text-align right
      @media (max-width: $breakpoints.md)
        text-align center
      & a
        color #056ED6
        margin 0
        &:hover
          text-decoration underline
  .submit-button
    font-size 20px
    height 48px
    margin-top 5px
    background #68BA62
    max-width 240px
    min-width 120px
    width 100%
    @media (max-width: $breakpoints.md)
      font-size 16px
      max-width unset
      min-width unset
  .login
    background #0743bf1c
    padding 15px
    border-radius 6px
</style>
